import React, { FC } from 'react';
import { SettingsFormPageSkeleton, SettingsTablePageSkeleton } from '../settingsSkeleton';

export const ColorPaletteSettingsPageSkeleton: FC = () => <SettingsTablePageSkeleton />;
export const PaletteColorsPageSkeleton: FC = () => <SettingsTablePageSkeleton />;
export const PantoneLibraryPageSkeleton: FC = () => <SettingsTablePageSkeleton />;
export const SellerPantoneColorsPageSkeleton: FC = () => <SettingsFormPageSkeleton />;
